import { combineReducers } from 'redux'
import { quizReducer } from './Quiz.reducer'
import { wizardReducer } from './Wizard.reducer'
import { resultsReducer } from './Results.reducer'

export const reducers = ({ quiz, wizard, results }, action) => {
  console.info('Action', action)
  console.info('State', { quiz, wizard, results })
  return {
    wizard: wizardReducer(wizard, action),
    quiz: quizReducer(quiz, action),
    results: resultsReducer(results, action)
  }
}



// WEBPACK FOOTER //
// ./src/js/quiz/state/reducers/Root.reducer.jsx